<template>
  <div>
    <el-row>
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="productDetailAppraiseInfo.appraises" border style="width: 100%" size="small">
        <el-table-column prop="prodName" label="商品名称" align="center" />
        <el-table-column prop="appraiseUserName" label="用户" align="center" />
        <el-table-column prop="appraiseScore" label="评分" align="center" />
        <el-table-column prop="context" label="内容" align="center" />
        <el-table-column prop="imgPath" label="图片" align="center" />
        <el-table-column prop="createTime" label="评论时间" align="center" />
      </el-table>

      <el-row class="margin-top">
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="pagination.currentPage"
            :page-size="pagination.pageSize" layout="total, prev, pager, next" :total="pagination.total" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryShopAppraise } from '@/api/goods/productDetailApi'

export default {
  name: 'ProductDetailAppraise',
  data() {
    return {
      productDetailAppraiseInfo: {
        appraises: [],
        productId: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    open(params) {
      this.productDetailAppraiseInfo.productId = params.productId
      this.loadProductDetailAppraiseData()
    },
    async loadProductDetailAppraiseData() {
      const res = await queryShopAppraise({
          objId: this.productDetailAppraiseInfo.productId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize,
          shopId: getShopId()
      })
      this.productDetailAppraiseInfo.appraises = res.data
      this.pagination.total = res.records
    },
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadProductDetailAppraiseData()
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>